<template>
  <page>
    <div>
      <v-card>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12>
                <form ref="TXTForm1">
                  <input type="file" style="display: none" ref="TXTfile1" :accept="'.txt' || '.TXT'" @change="doValidateFile" />
                </form>
                <v-text-field
                  readonly
                  v-model="form.requestedFile1"
                  :label="labels.requestedFile1"
                  :error-messages="errors.collect('requestedFile1')"
                  data-vv-name="requestedFile1"
                  :data-vv-as="labels.requestedFile1"
                  append-icon="mdi-magnify"
                  @click:append="pickFile1"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-btn color="primary" dark class="mr-2" @click="doSend">
              Upload
              <v-icon left dark>mdi-file-export</v-icon>
            </v-btn>
            <v-btn-toggle dense mandatory v-model="form.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{ format.label }}</span>
                <v-icon :color="format.color">{{ format.icon }}</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
export default {
  data() {
    return {
      uploading: false,
      labels: {
        requestedFile1: 'UOB Upload File'
      },
      form: {
        requestedFile1: '',
        format: 'PDF'
      },
      textDataTransferObject: [],
      supportedFormat: []
    }
  },
  watch: {
    supportedList: function (value) {
      if (value && value.length > 0) {
        this.form.format = value[0].value
      }
    }
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('custom2ReportsInit')])
      const apiUrl = this.$store.state.reports.custom2Reports.menu.initUobInstructionSlip
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          if (result.data) {
            const { data } = result.data
            if (data) {
              this.supportedFormat = data.format
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
          }
          this.processing = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. [initMasAML]')
      }
    },
    doValidateFile(e) {
      this.form.requestedFile1 = ''
      this.resetMessages()
      if (e.target.files[0]) {
        this.uploading = true
        const file = e.target.files[0]
        if (file.name.indexOf('.txt') !== -1 || file.name.indexOf('.TXT') !== -1) {
          var filehead = file.name.substring(0, 6)
          if (filehead === 'UIPC04') {
            this.form.requestedFile1 = file.name
            const fileReader = new FileReader()
            fileReader.readAsText(file)
            fileReader.onload = async () => {
              var lines = fileReader.result.split('\n')
              let dataObj = []
              let headerRecord = []
              let detailRecord = []
              let trailerRecord = []
              if (lines.length > 1) {
                if (lines[0].substring(0, 1) === '1') {
                  headerRecord = lines[0]
                  trailerRecord = lines[lines.length - 1]
                  for (var i = 1; i < lines.length - 1; i++) {
                    detailRecord.push({
                      detailLine: lines[i]
                    })
                  }
                  dataObj = {
                    headerRecord: headerRecord,
                    detailRecord: detailRecord,
                    trailerRecord: trailerRecord
                  }
                  if (this.textDataTransferObject.length > 1) {
                    this.textDataTransferObject.splice(0, 1, dataObj)
                  } else {
                    this.textDataTransferObject.push({
                      headerRecord: headerRecord,
                      detailRecord: detailRecord,
                      trailerRecord: trailerRecord
                    })
                  }
                } else {
                  this.$toast.error('Upload unsuccessful - Invalid Record Header')
                  this.form.requestedFile1 = ''
                }
              } else {
                this.$toast.error('No Line Is Found On The Text File Uploaded')
              }
            }
          } else {
            this.$toast.error('Upload File 1 filename must starts with UIPC04')
          }
        } else {
          this.$toast.error('Please Select Text File (.txt) Only!')
        }
      }
      this.uploading = false
      this.doUpload(e)
    },
    pickFile1() {
      this.$refs.TXTForm1.reset()
      this.$refs.TXTfile1.click()
    },
    async getFile(event) {
      this.file = event.target.files[0]
    },
    async doUpload(event) {
      await this.getFile(event)
    },
    async doSend() {
      const dto = []
      dto.push({
        dataUploaded: this.textDataTransferObject,
        format: this.form.format,
        sendEmail: false
      })
      const apiURI = this.$store.state.reports.custom2Reports.menu.uploadUOBInstructionSlip
      const apiURI2 = this.$store.state.reports.custom2Reports.menu.uploadUOBInstructionSlipDetails
      if (apiURI && apiURI2 && this.form.format === 'PDF') {
        this.uploading = true
        try {
          await this.$http.post(apiURI, dto[0])
          await this.$http.post(apiURI2, dto[0])
          if (this.textDataTransferObject[0].headerRecord.substring(4, 12) !==
            this.textDataTransferObject[1].headerRecord.substring(4, 12)) {
            this.$toast.error('Upload unsuccessful - Different Processing Date')
          } else {
            await this.$http.post(apiURI, dto[0])
            await this.$http.post(apiURI2, dto[0])
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.uploading = false
      } else if (apiURI && this.form.format === 'XLSX') {
        this.uploading = true
        try {
          await this.$http.post(apiURI, dto[0])
          if (this.textDataTransferObject[0].headerRecord.substring(4, 12) !==
            this.textDataTransferObject[1].headerRecord.substring(4, 12)) {
            this.$toast.error('Upload unsuccessful - Different Processing Date')
          } else {
            await this.$http.post(apiURI, dto[0])
            await this.$http.post(apiURI2, dto[0])
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$toast.error('Request Mapping Not Found!')
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit')
    }
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin]
}
</script>
